import BaseViewModel from "../../Models/BaseViewModel";
import { BaseScript } from "./BaseScript";
import { EmailValidator, OgrnIpValidator, OgrnValidator, SnilsValidator, PhysicalInnValidator, JuridicalInnValidator } from "../Validators";
import { ScriptDescriptionType, ScriptTypes } from "../../Types";

export class ValidationScript extends BaseScript {

	path: string | null = null;
	validatorType: string | null = null;
	// element: string | null = element;

	validators: any = {
		Email: new EmailValidator(),
		Snils: new SnilsValidator(),
		PhysicalInn: new PhysicalInnValidator(),
		JuridicalInn: new JuridicalInnValidator(),
		Ogrn: new OgrnValidator(),
		OgrnIp: new OgrnIpValidator()
	};

	constructor ( contextElement: BaseViewModel, script: ScriptDescriptionType, scriptPurpose: string ) {
		// 	Вызов конструктора родителя.
		super( contextElement, script, scriptPurpose );
		const matches = this.Content?.match(/^(\w+):\s(.+)/);
		if (matches && matches.length === 3) {
			this.ScriptType = matches[1] as ScriptTypes;
			this.validatorType = matches[2];
		}
	};

	/** Запустить скрипт в контексте hostObject */
	runScript = () => {
		if ( !this.Content || !this.validatorType || !this.validators[this.validatorType] ) return null;
		try {
			return this.validators[this.validatorType].validate( this.contextElement.Value );
		} 
		catch ( e: any ) {
			console.warn(e.message);
		}
		return null;
	};

	gMessage = () => {
		if ( !this.Content || !this.validatorType || !this.validators[this.validatorType] ) return null;
		return this.validators[this.validatorType].message;
	};

};
